import { render, staticRenderFns } from "./ProgramCheck.vue?vue&type=template&id=5dbdd5f6"
import script from "./ProgramCheck.vue?vue&type=script&lang=js"
export * from "./ProgramCheck.vue?vue&type=script&lang=js"
import style0 from "./ProgramCheck.vue?vue&type=style&index=0&id=5dbdd5f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports